import script from "./EmptyList.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmptyList.vue?vue&type=script&setup=true&lang=ts"

import "./EmptyList.vue?vue&type=style&index=0&id=5f1d1d8c&lang=css"

const __exports__ = script;

export default __exports__